export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/azadi-gif.ccb32472.gif","height":1000,"width":1000,"blurWidth":0,"blurHeight":0};